module.exports = __webpack_public_path__ + "static/media/logo.55fe3ea1.svg";